export const FREE_PLAN_FEATURES: readonly string[] = [
  "Do-follow backlink (badge required)",
] as const;

export const ALL_PLAN_FEATURES: readonly string[] = [
  "Unlimited website analyses",
  "High authority do-follow backlink",
  "Website score badge",
  "Daily automated monitoring (up to 10 domains)",
  "Critical change alerts",
  "History tracking",
  "Certified report page",
  "Copy to LLM",
] as const;

export const FEATURES_SCOPE_LABEL: string = "Everything you'll get";

export const SHOW_FEATURED_SPOT_UI = false;
